import BaseHelper from './BaseHelper'

var debounced
export default class ExportHelper extends BaseHelper {
  static afterDraw() {
    const self = this
    clearTimeout(debounced)
    debounced = setTimeout(() => {
      self.$root.setAttribute('id', 'graph-ready')
    }, 200)
  }

  static update() {
    const self = this
    clearTimeout(debounced)
    debounced = setTimeout(() => {
      self.$root.setAttribute('id', 'graph-ready')
    }, 200)
  }
}
